/* cSpell:disable */
import React from 'react';

import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';

import { SelectValueAb } from './selectValue.ab';
import { SelectValueBcp } from './selectValue.bcp';

export interface SelectValueProps {
	defaultValues?: number[];
	value: number;
	minValue: number;
	maxValue: number;
	onChange: (value: number, isFinalUpdate?: boolean) => void;
	disable?: boolean;
}

export const SelectValue: React.FC<SelectValueProps> = (props: SelectValueProps): JSX.Element => {
	return (
		<RenderComponent
			components={{
				ab: { desktop: <SelectValueAb {...props} />, mobile: <SelectValueAb {...props} />, intranet: null },
				bcp: { desktop: <SelectValueBcp {...props} />, mobile: <SelectValueBcp {...props} />, intranet: null },
			}}
		/>
	);
};
/* cSpell:enable */
